export type CoverLetterLayout = "divider" | "block" | "centered" | "formal-serif";

export type CoverLetterTemplate = {
  id: string;
  label: string;
  tag: string;
  description: string;
  preview: { bg: string; accent: string };
  layout: CoverLetterLayout;
  accentColor: string;
  fontFamily: string;
};

// Four structurally distinct layouts (not just recolors of one design) —
// each changes how the header/name block is built, not only its color.
export const COVER_LETTER_TEMPLATES: CoverLetterTemplate[] = [
  {
    id: "modern-divider",
    label: "Modern Divider",
    tag: "Default",
    description: "Clean left-aligned header with a bold accent-color divider beneath your name and contact line.",
    preview: { bg: "#f5f3ff", accent: "#7c3aed" },
    layout: "divider",
    accentColor: "#7c3aed",
    fontFamily: "Geist",
  },
  {
    id: "bold-block",
    label: "Bold Header Block",
    tag: "Standout",
    description: "A solid accent-color band across the top holds your name and contact info in white — the rest of the letter stays plain and readable.",
    preview: { bg: "#eff6ff", accent: "#2563eb" },
    layout: "block",
    accentColor: "#2563eb",
    fontFamily: "Inter, sans-serif",
  },
  {
    id: "minimal-centered",
    label: "Minimal Centered",
    tag: "Understated",
    description: "Centered name and contact line with a thin rule beneath — quiet, conservative, and works well for any industry.",
    preview: { bg: "#ffffff", accent: "#111827" },
    layout: "centered",
    accentColor: "#111827",
    fontFamily: "Arial, Helvetica, sans-serif",
  },
  {
    id: "classic-formal",
    label: "Classic Formal",
    tag: "Traditional",
    description: "Traditional business-letter format in serif type with a right-aligned date — no color accent, maximum formality.",
    preview: { bg: "#f8fafc", accent: "#0f172a" },
    layout: "formal-serif",
    accentColor: "#0f172a",
    fontFamily: "Lora, serif",
  },
];

export function getCoverLetterTemplate(id: string): CoverLetterTemplate | undefined {
  return COVER_LETTER_TEMPLATES.find((t) => t.id === id);
}
